import { render, staticRenderFns } from "./markLabel.vue?vue&type=template&id=335c2766&scoped=true"
import script from "./markLabel.vue?vue&type=script&lang=js"
export * from "./markLabel.vue?vue&type=script&lang=js"
import style0 from "./markLabel.vue?vue&type=style&index=0&id=335c2766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c2766",
  null
  
)

export default component.exports